module.exports = __webpack_public_path__ + "img/106050.16051890.png";